import { lazy } from 'react';

export const BankBranchesPage = lazy(
  () => import('./ui/BankBranchesPage/BankBranchesPage'),
);

export const BankBranchesDetailsPage = lazy(
  () => import('./ui/BankBranchesDetailsPage/BankBranchesDetailsPage.tsx'),
);
